export const CartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
    <path
      d="M9.33325 29.5661C8.59992 29.5661 7.97214 29.305 7.44992 28.7827C6.9277 28.2605 6.66659 27.6327 6.66659 26.8994C6.66659 26.1661 6.9277 25.5383 7.44992 25.0161C7.97214 24.4939 8.59992 24.2327 9.33325 24.2327C10.0666 24.2327 10.6944 24.4939 11.2166 25.0161C11.7388 25.5383 11.9999 26.1661 11.9999 26.8994C11.9999 27.6327 11.7388 28.2605 11.2166 28.7827C10.6944 29.305 10.0666 29.5661 9.33325 29.5661ZM22.6666 29.5661C21.9333 29.5661 21.3055 29.305 20.7833 28.7827C20.261 28.2605 19.9999 27.6327 19.9999 26.8994C19.9999 26.1661 20.261 25.5383 20.7833 25.0161C21.3055 24.4939 21.9333 24.2327 22.6666 24.2327C23.3999 24.2327 24.0277 24.4939 24.5499 25.0161C25.0721 25.5383 25.3333 26.1661 25.3333 26.8994C25.3333 27.6327 25.0721 28.2605 24.5499 28.7827C24.0277 29.305 23.3999 29.5661 22.6666 29.5661ZM8.19992 8.23275L11.3999 14.8994H20.7333L24.3999 8.23275H8.19992ZM6.93325 5.56608H26.5999C27.111 5.56608 27.4999 5.79386 27.7666 6.24941C28.0333 6.70497 28.0444 7.16608 27.7999 7.63275L23.0666 16.1661C22.8221 16.6105 22.4944 16.955 22.0833 17.1994C21.6721 17.4439 21.2221 17.5661 20.7333 17.5661H10.7999L9.33325 20.2327H25.3333V22.8994H9.33325C8.33325 22.8994 7.5777 22.4605 7.06659 21.5827C6.55547 20.705 6.53325 19.8327 6.99992 18.9661L8.79992 15.6994L3.99992 5.56608H1.33325V2.89941H5.66659L6.93325 5.56608Z"
      fill="black"
    />
  </svg>
);
export const CancelIconSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.size || "62"}
    height={props?.size || "62"}
    viewBox="0 0 62 62"
    fill="none"
  >
    <path
      d="M15.5 46.5L46.5 15.5M15.5 15.5L46.5 46.5"
      stroke={props?.color || "white"}
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CancelVerifyModalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.size || "24"}
    height={props?.size || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 18L18 6M6 6L18 18"
      stroke={props?.color || "white"}
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PencilIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clip-path="url(#clip0_47_6181)">
      <path
        d="M10.545 6.765L11.235 7.455L4.44 14.25H3.75V13.56L10.545 6.765ZM13.245 2.25C13.0575 2.25 12.8625 2.325 12.72 2.4675L11.3475 3.84L14.16 6.6525L15.5325 5.28C15.825 4.9875 15.825 4.515 15.5325 4.2225L13.7775 2.4675C13.6275 2.3175 13.44 2.25 13.245 2.25ZM10.545 4.6425L2.25 12.9375V15.75H5.0625L13.3575 7.455L10.545 4.6425Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_47_6181">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TriangleIconProfileView = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 12" fill="none">
    <path d="M7 0L13.9282 12H0.0717969L7 0Z" fill="white" />
  </svg>
);

export const SearchIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clip-path="url(#clip0_102_503)">
      <path
        d="M16 14.5H15.21L14.93 14.23C15.91 13.09 16.5 11.61 16.5 10C16.5 6.41 13.59 3.5 10 3.5C6.41 3.5 3.5 6.41 3.5 10C3.5 13.59 6.41 16.5 10 16.5C11.61 16.5 13.09 15.91 14.23 14.93L14.5 15.21V16L19.5 20.99L20.99 19.5L16 14.5ZM10 14.5C7.51 14.5 5.5 12.49 5.5 10C5.5 7.51 7.51 5.5 10 5.5C12.49 5.5 14.5 7.51 14.5 10C14.5 12.49 12.49 14.5 10 14.5Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_503">
        <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const CartIcons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M9.66671 7.49967V4.99967H7.16671V3.33301H9.66671V0.833008H11.3334V3.33301H13.8334V4.99967H11.3334V7.49967H9.66671ZM6.33337 18.333C5.87504 18.333 5.48268 18.1698 5.15629 17.8434C4.8299 17.517 4.66671 17.1247 4.66671 16.6663C4.66671 16.208 4.8299 15.8156 5.15629 15.4893C5.48268 15.1629 5.87504 14.9997 6.33337 14.9997C6.79171 14.9997 7.18407 15.1629 7.51046 15.4893C7.83685 15.8156 8.00004 16.208 8.00004 16.6663C8.00004 17.1247 7.83685 17.517 7.51046 17.8434C7.18407 18.1698 6.79171 18.333 6.33337 18.333ZM14.6667 18.333C14.2084 18.333 13.816 18.1698 13.4896 17.8434C13.1632 17.517 13 17.1247 13 16.6663C13 16.208 13.1632 15.8156 13.4896 15.4893C13.816 15.1629 14.2084 14.9997 14.6667 14.9997C15.125 14.9997 15.5174 15.1629 15.8438 15.4893C16.1702 15.8156 16.3334 16.208 16.3334 16.6663C16.3334 17.1247 16.1702 17.517 15.8438 17.8434C15.5174 18.1698 15.125 18.333 14.6667 18.333ZM1.33337 3.33301V1.66634H4.06254L7.60421 9.16634H13.4375L16.6875 3.33301H18.5834L14.9167 9.95801C14.7639 10.2358 14.5591 10.4511 14.3021 10.6038C14.0452 10.7566 13.7639 10.833 13.4584 10.833H7.25004L6.33337 12.4997H16.3334V14.1663H6.33337C5.70837 14.1663 5.23268 13.8955 4.90629 13.3538C4.5799 12.8122 4.56949 12.2636 4.87504 11.708L6.00004 9.66634L3.00004 3.33301H1.33337Z"
      fill="white"
    />
  </svg>
);
export const QuestionMarkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M7.40925 5.63925C8.2875 4.8705 9.7125 4.8705 10.5908 5.63925C11.4698 6.408 11.4698 7.6545 10.5908 8.42325C10.4385 8.5575 10.2683 8.66775 10.0883 8.75475C9.5295 9.0255 9.00075 9.504 9.00075 10.125V10.6875M15.75 9C15.75 9.88642 15.5754 10.7642 15.2362 11.5831C14.897 12.4021 14.3998 13.1462 13.773 13.773C13.1462 14.3998 12.4021 14.897 11.5831 15.2362C10.7642 15.5754 9.88642 15.75 9 15.75C8.11358 15.75 7.23583 15.5754 6.41689 15.2362C5.59794 14.897 4.85382 14.3998 4.22703 13.773C3.60023 13.1462 3.10303 12.4021 2.76381 11.5831C2.42459 10.7642 2.25 9.88642 2.25 9C2.25 7.20979 2.96116 5.4929 4.22703 4.22703C5.4929 2.96116 7.20979 2.25 9 2.25C10.7902 2.25 12.5071 2.96116 13.773 4.22703C15.0388 5.4929 15.75 7.20979 15.75 9ZM9 12.9375H9.006V12.9435H9V12.9375Z"
      stroke="black"
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PrimaryTickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 16C3 8.82 8.82 3 16 3C23.18 3 29 8.82 29 16C29 23.18 23.18 29 16 29C8.82 29 3 23.18 3 16ZM20.8133 13.5813C20.8933 13.4747 20.9512 13.3532 20.9836 13.2239C21.0159 13.0946 21.0221 12.9602 21.0018 12.8285C20.9815 12.6968 20.935 12.5704 20.8651 12.4569C20.7953 12.3434 20.7034 12.245 20.595 12.1675C20.4866 12.09 20.3638 12.035 20.2337 12.0056C20.1037 11.9763 19.9692 11.9732 19.838 11.9966C19.7068 12.02 19.5816 12.0694 19.4697 12.1419C19.3579 12.2144 19.2616 12.3085 19.1867 12.4187L14.872 18.4587L12.7067 16.2933C12.5171 16.1167 12.2664 16.0205 12.0073 16.0251C11.7482 16.0297 11.5011 16.1346 11.3178 16.3178C11.1346 16.5011 11.0297 16.7482 11.0251 17.0073C11.0205 17.2664 11.1167 17.5171 11.2933 17.7067L14.2933 20.7067C14.396 20.8092 14.5197 20.8882 14.656 20.9382C14.7922 20.9881 14.9377 21.0078 15.0824 20.9959C15.227 20.984 15.3673 20.9407 15.4935 20.8691C15.6197 20.7975 15.7289 20.6993 15.8133 20.5813L20.8133 13.5813Z"
      fill="#2B74D8"
    />
  </svg>
);

export const SecondaryTickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
    <path
      d="M12 17.5L15 20.5L20 13.5M28 16.5C28 18.0759 27.6896 19.6363 27.0866 21.0922C26.4835 22.5481 25.5996 23.871 24.4853 24.9853C23.371 26.0996 22.0481 26.9835 20.5922 27.5866C19.1363 28.1896 17.5759 28.5 16 28.5C14.4241 28.5 12.8637 28.1896 11.4078 27.5866C9.95189 26.9835 8.62902 26.0996 7.51472 24.9853C6.40042 23.871 5.5165 22.5481 4.91345 21.0922C4.31039 19.6363 4 18.0759 4 16.5C4 13.3174 5.26428 10.2652 7.51472 8.01472C9.76516 5.76428 12.8174 4.5 16 4.5C19.1826 4.5 22.2348 5.76428 24.4853 8.01472C26.7357 10.2652 28 13.3174 28 16.5Z"
      stroke="#2B74D8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CorrectDomain = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_38_3879)">
      <path
        d="M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z"
        fill={color || "#2F80ED"}
      />
    </g>
    <defs>
      <clipPath id="clip0_38_3879">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21.7212 12.7524C21.8568 11.0303 21.5305 9.30331 20.7762 7.74937C19.5275 8.93576 18.0515 9.85695 16.4372 10.4574C16.567 12.0507 16.4951 13.654 16.2232 15.2294C18.1877 14.7346 20.049 13.896 21.7212 12.7524ZM14.6342 15.5504C14.9536 14.0234 15.0653 12.4602 14.9662 10.9034C14.0142 11.1304 13.0212 11.2504 12.0002 11.2504C10.9792 11.2504 9.98619 11.1304 9.03419 10.9034C8.93743 12.4602 9.04908 14.0231 9.36619 15.5504C11.112 15.818 12.8884 15.818 14.6342 15.5504ZM9.77219 17.1194C11.2524 17.2945 12.748 17.2945 14.2282 17.1194C13.7195 18.7569 12.9685 20.3091 12.0002 21.7244C11.0319 20.3092 10.2809 18.757 9.77219 17.1194ZM7.77719 15.2304C7.50383 13.6545 7.43192 12.0503 7.56319 10.4564C5.94847 9.85609 4.47211 8.93489 3.22319 7.74837C2.469 9.3027 2.14313 11.0301 2.27919 12.7524C3.95133 13.896 5.81271 14.7356 7.77719 15.2304ZM21.3562 14.7524C20.8513 16.4633 19.8874 18.0033 18.5691 19.205C17.2507 20.4068 15.6284 21.2245 13.8782 21.5694C14.7547 20.0956 15.4237 18.508 15.8662 16.8514C17.7957 16.447 19.6487 15.7388 21.3562 14.7534V14.7524ZM2.64419 14.7524C4.32619 15.7234 6.17419 16.4404 8.13419 16.8514C8.57669 18.508 9.24567 20.0956 10.1222 21.5694C8.37208 21.2246 6.74983 20.407 5.43153 19.2055C4.11323 18.0039 3.14924 16.4641 2.64419 14.7534V14.7524ZM13.8782 2.43037C16.3559 2.91738 18.5483 4.3462 19.9942 6.41637C18.9269 7.49475 17.6527 8.34644 16.2482 8.92037C15.8698 6.62818 15.0659 4.427 13.8782 2.43037ZM12.0002 2.27637C13.4596 4.40847 14.4185 6.84273 14.8052 9.39737C13.9082 9.62737 12.9682 9.75037 12.0002 9.75037C11.0322 9.75037 10.0922 9.62837 9.19519 9.39737C9.58187 6.84272 10.5407 4.40845 12.0002 2.27637ZM10.1222 2.43037C8.93442 4.42699 8.13059 6.62818 7.75219 8.92037C6.34764 8.34647 5.0735 7.49477 4.00619 6.41637C5.45222 4.3465 7.64458 2.91703 10.1222 2.43037Z"
      fill="#2B74D8"
    />
  </svg>
);

export function EmailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#2B74D8"
        d="M21.23 18.07l-5.38-5.05-3.201 3.039-3.203-3.039-5.378 5.05h17.161zM22.296 17.126V6.944l-5.419 5.091 5.42 5.091zM8.42 12.035L3 6.945v10.181l5.42-5.09z"
      ></path>
      <path fill="#2B74D8" d="M12.649 14.088L21.229 6H4.068l8.58 8.088z"></path>
    </svg>
  );
}

export const SecureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.516 2.16958C12.3767 2.03749 12.192 1.96387 12 1.96387C11.808 1.96387 11.6233 2.03749 11.484 2.16958C9.36128 4.18547 6.53413 5.29091 3.60701 5.24958C3.44754 5.24751 3.29157 5.29632 3.16173 5.38894C3.0319 5.48155 2.93496 5.61313 2.88501 5.76458C2.46298 7.05075 2.24862 8.39595 2.25001 9.74958C2.25001 15.6916 6.31401 20.6826 11.813 22.0976C11.9357 22.1292 12.0643 22.1292 12.187 22.0976C17.686 20.6826 21.75 15.6916 21.75 9.74958C21.75 8.35958 21.527 7.01958 21.115 5.76458C21.0652 5.61294 20.9684 5.48114 20.8385 5.38834C20.7087 5.29554 20.5526 5.24658 20.393 5.24858L20.25 5.24958C17.254 5.24958 14.533 4.07958 12.516 2.16958ZM15.61 10.1856C15.67 10.1056 15.7134 10.0145 15.7377 9.91753C15.762 9.82057 15.7666 9.71973 15.7514 9.62094C15.7361 9.52215 15.7013 9.42741 15.6489 9.34228C15.5965 9.25715 15.5276 9.18336 15.4463 9.12523C15.3649 9.06711 15.2728 9.02583 15.1753 9.00381C15.0778 8.9818 14.9769 8.9795 14.8785 8.99705C14.7801 9.01459 14.6862 9.05164 14.6023 9.106C14.5184 9.16035 14.4462 9.23093 14.39 9.31358L11.154 13.8436L9.53001 12.2196C9.38783 12.0871 9.19979 12.015 9.00548 12.0184C8.81118 12.0218 8.6258 12.1005 8.48839 12.238C8.35097 12.3754 8.27226 12.5608 8.26883 12.7551C8.2654 12.9494 8.33753 13.1374 8.47001 13.2796L10.72 15.5296C10.797 15.6065 10.8898 15.6658 10.992 15.7032C11.0942 15.7407 11.2033 15.7555 11.3118 15.7465C11.4202 15.7376 11.5255 15.7051 11.6201 15.6514C11.7148 15.5977 11.7967 15.5241 11.86 15.4356L15.61 10.1856Z"
      fill="#2B74D8"
    />
  </svg>
);

export const SecondaryCartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M13.7332 10.6667V6.66667H9.73324V4H13.7332V0H16.3999V4H20.3999V6.66667H16.3999V10.6667H13.7332ZM8.3999 28C7.66657 28 7.03879 27.7389 6.51657 27.2167C5.99435 26.6944 5.73324 26.0667 5.73324 25.3333C5.73324 24.6 5.99435 23.9722 6.51657 23.45C7.03879 22.9278 7.66657 22.6667 8.3999 22.6667C9.13324 22.6667 9.76101 22.9278 10.2832 23.45C10.8055 23.9722 11.0666 24.6 11.0666 25.3333C11.0666 26.0667 10.8055 26.6944 10.2832 27.2167C9.76101 27.7389 9.13324 28 8.3999 28ZM21.7332 28C20.9999 28 20.3721 27.7389 19.8499 27.2167C19.3277 26.6944 19.0666 26.0667 19.0666 25.3333C19.0666 24.6 19.3277 23.9722 19.8499 23.45C20.3721 22.9278 20.9999 22.6667 21.7332 22.6667C22.4666 22.6667 23.0943 22.9278 23.6166 23.45C24.1388 23.9722 24.3999 24.6 24.3999 25.3333C24.3999 26.0667 24.1388 26.6944 23.6166 27.2167C23.0943 27.7389 22.4666 28 21.7332 28ZM0.399902 4V1.33333H4.76657L10.4332 13.3333H19.7666L24.9666 4H27.9999L22.1332 14.6C21.8888 15.0444 21.561 15.3889 21.1499 15.6333C20.7388 15.8778 20.2888 16 19.7999 16H9.86657L8.3999 18.6667H24.3999V21.3333H8.3999C7.3999 21.3333 6.63879 20.9 6.11657 20.0333C5.59435 19.1667 5.57768 18.2889 6.06657 17.4L7.86657 14.1333L3.06657 4H0.399902Z"
      fill="black"
      fill-opacity="0.8"
    />
  </svg>
);

export const UnAvailableDomainIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 3C8.82 3 3 8.82 3 16C3 23.18 8.82 29 16 29C23.18 29 29 23.18 29 16C29 8.82 23.18 3 16 3ZM13.7067 12.2933C13.6151 12.1951 13.5047 12.1163 13.3821 12.0616C13.2594 12.007 13.127 11.9776 12.9927 11.9752C12.8584 11.9728 12.7251 11.9975 12.6005 12.0478C12.476 12.0981 12.3629 12.173 12.268 12.268C12.173 12.3629 12.0981 12.476 12.0478 12.6005C11.9975 12.7251 11.9728 12.8584 11.9752 12.9927C11.9776 13.127 12.007 13.2594 12.0616 13.3821C12.1163 13.5047 12.1951 13.6151 12.2933 13.7067L14.5867 16L12.2933 18.2933C12.1951 18.3849 12.1163 18.4953 12.0616 18.6179C12.007 18.7406 11.9776 18.873 11.9752 19.0073C11.9728 19.1416 11.9975 19.2749 12.0478 19.3995C12.0981 19.524 12.173 19.6371 12.268 19.7321C12.3629 19.827 12.476 19.9019 12.6005 19.9522C12.7251 20.0025 12.8584 20.0272 12.9927 20.0248C13.127 20.0224 13.2594 19.993 13.3821 19.9384C13.5047 19.8837 13.6151 19.8049 13.7067 19.7067L16 17.4133L18.2933 19.7067C18.3849 19.8049 18.4953 19.8837 18.6179 19.9384C18.7406 19.993 18.873 20.0224 19.0073 20.0248C19.1416 20.0272 19.2749 20.0025 19.3995 19.9522C19.524 19.9019 19.6371 19.827 19.7321 19.7321C19.827 19.6371 19.9019 19.524 19.9522 19.3995C20.0025 19.2749 20.0272 19.1416 20.0248 19.0073C20.0224 18.873 19.993 18.7406 19.9384 18.6179C19.8837 18.4953 19.8049 18.3849 19.7067 18.2933L17.4133 16L19.7067 13.7067C19.8049 13.6151 19.8837 13.5047 19.9384 13.3821C19.993 13.2594 20.0224 13.127 20.0248 12.9927C20.0272 12.8584 20.0025 12.7251 19.9522 12.6005C19.9019 12.476 19.827 12.3629 19.7321 12.268C19.6371 12.173 19.524 12.0981 19.3995 12.0478C19.2749 11.9975 19.1416 11.9728 19.0073 11.9752C18.873 11.9776 18.7406 12.007 18.6179 12.0616C18.4953 12.1163 18.3849 12.1951 18.2933 12.2933L16 14.5867L13.7067 12.2933Z"
      fill="#D91100"
    />
  </svg>
);

export const PriceModalCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_206_2835)">
      <path
        d="M8.99991 16.1698L4.82991 11.9998L3.40991 13.4098L8.99991 18.9998L20.9999 6.99984L19.5899 5.58984L8.99991 16.1698Z"
        fill="black"
        fill-opacity="0.6"
      />
    </g>
    <defs>
      <clipPath id="clip0_206_2835">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DeleteIcon = () => {
  return (
    <svg id="deleteIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M12.2833 7.50043L11.995 15.0004M8.005 15.0004L7.71667 7.50043M16.0233 4.82543C16.3083 4.86877 16.5917 4.9146 16.875 4.96377M16.0233 4.82543L15.1333 16.3946C15.097 16.8656 14.8842 17.3056 14.5375 17.6265C14.1908 17.9474 13.7358 18.1256 13.2633 18.1254H6.73667C6.26425 18.1256 5.80919 17.9474 5.46248 17.6265C5.11578 17.3056 4.90299 16.8656 4.86667 16.3946L3.97667 4.82543M16.0233 4.82543C15.0616 4.68003 14.0948 4.56968 13.125 4.4946M3.97667 4.82543C3.69167 4.86793 3.40833 4.91377 3.125 4.96293M3.97667 4.82543C4.93844 4.68003 5.9052 4.56968 6.875 4.4946M13.125 4.4946V3.73127C13.125 2.74793 12.3667 1.92793 11.3833 1.8971C10.4613 1.86763 9.53865 1.86763 8.61667 1.8971C7.63333 1.92793 6.875 2.74877 6.875 3.73127V4.4946M13.125 4.4946C11.0448 4.33383 8.95523 4.33383 6.875 4.4946"
        stroke="black"
        stroke-opacity="0.6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export function LockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 1.25C9.33968 1.25 8.22688 1.71094 7.40641 2.53141C6.58594 3.35188 6.125 4.46468 6.125 5.625V8.125C5.46196 8.125 4.82607 8.38839 4.35723 8.85723C3.88839 9.32607 3.625 9.96196 3.625 10.625V16.25C3.625 16.913 3.88839 17.5489 4.35723 18.0178C4.82607 18.4866 5.46196 18.75 6.125 18.75H14.875C15.538 18.75 16.1739 18.4866 16.6428 18.0178C17.1116 17.5489 17.375 16.913 17.375 16.25V10.625C17.375 9.96196 17.1116 9.32607 16.6428 8.85723C16.1739 8.38839 15.538 8.125 14.875 8.125V5.625C14.875 3.20833 12.9167 1.25 10.5 1.25ZM13.625 8.125V5.625C13.625 4.7962 13.2958 4.00134 12.7097 3.41529C12.1237 2.82924 11.3288 2.5 10.5 2.5C9.6712 2.5 8.87634 2.82924 8.29029 3.41529C7.70424 4.00134 7.375 4.7962 7.375 5.625V8.125H13.625Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  );
}

export const GreenTick = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_109_1595)">
      <rect width="20" height="20" fill="white" />
      <path
        d="M10 0C4.48622 0 0 4.48622 0 10C0 15.5138 4.48622 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48622 15.5138 0 10 0ZM15.589 7.36842L9.198 13.7093C8.82206 14.0852 8.22055 14.1103 7.81955 13.7343L4.43609 10.6516C4.03509 10.2757 4.01003 9.64912 4.3609 9.24812C4.73684 8.84712 5.36341 8.82206 5.76441 9.198L8.44612 11.6541L14.1604 5.93985C14.5614 5.53885 15.188 5.53885 15.589 5.93985C15.99 6.34085 15.99 6.96742 15.589 7.36842Z"
        fill="#219653"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_1595">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CallbackIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.4324 21.0051C27.4732 21.0051 25.5494 20.6987 23.7264 20.0962C22.8332 19.7915 21.735 20.071 21.1899 20.631L17.5916 23.3472C13.4188 21.1198 10.8483 18.5502 8.65125 14.4086L11.2876 10.9041C11.9725 10.2201 12.2182 9.22091 11.9239 8.28338C11.3188 6.45081 11.0115 4.52799 11.0115 2.56792C11.0116 1.15196 9.85962 0 8.44374 0H2.56686C1.15098 0 -0.000976562 1.15196 -0.000976562 2.56784C-0.000976562 18.7976 13.2027 32.0011 29.4324 32.0011C30.8483 32.0011 32.0002 30.8492 32.0002 29.4333V23.5728C32.0002 22.157 30.8482 21.0051 29.4324 21.0051Z"
      fill="#2B74D8"
    />
  </svg>
);

export const MiniCancelIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 18L18 6M6 6L18 18" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const CartTickIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.5501 17.9996L3.8501 12.2996L5.2751 10.8746L9.5501 15.1496L18.7251 5.97461L20.1501 7.39961L9.5501 17.9996Z"
      fill={props?.color ? props?.color : "#2B74D8"}
    />
  </svg>
);

export const AddedCartIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
    <path
      d="M9.33337 29.8337C8.60004 29.8337 7.97226 29.5725 7.45004 29.0503C6.92782 28.5281 6.66671 27.9003 6.66671 27.167C6.66671 26.4337 6.92782 25.8059 7.45004 25.2837C7.97226 24.7614 8.60004 24.5003 9.33337 24.5003C10.0667 24.5003 10.6945 24.7614 11.2167 25.2837C11.7389 25.8059 12 26.4337 12 27.167C12 27.9003 11.7389 28.5281 11.2167 29.0503C10.6945 29.5725 10.0667 29.8337 9.33337 29.8337ZM22.6667 29.8337C21.9334 29.8337 21.3056 29.5725 20.7834 29.0503C20.2612 28.5281 20 27.9003 20 27.167C20 26.4337 20.2612 25.8059 20.7834 25.2837C21.3056 24.7614 21.9334 24.5003 22.6667 24.5003C23.4 24.5003 24.0278 24.7614 24.55 25.2837C25.0723 25.8059 25.3334 26.4337 25.3334 27.167C25.3334 27.9003 25.0723 28.5281 24.55 29.0503C24.0278 29.5725 23.4 29.8337 22.6667 29.8337ZM1.33337 5.83366V3.16699H5.70004L11.3667 15.167H20.7L25.9 5.83366H28.9334L23.0667 16.4337C22.8223 16.8781 22.4945 17.2225 22.0834 17.467C21.6723 17.7114 21.2223 17.8337 20.7334 17.8337H10.8L9.33337 20.5003H25.3334V23.167H9.33337C8.33337 23.167 7.57226 22.7337 7.05004 21.867C6.52782 21.0003 6.51115 20.1225 7.00004 19.2337L8.80004 15.967L4.00004 5.83366H1.33337Z"
      fill="#2B74D8"
    />
    <path
      d="M15.676 11.6996L11.2 7.14909L12.319 6.01146L15.676 9.42435L22.8809 2.09961L24 3.23724L15.676 11.6996Z"
      fill="#2B74D8"
    />
  </svg>
);

export const DownDropArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_1241_1051)">
      <path d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z" fill="#0E0E0E" />
    </g>
    <defs>
      <clipPath id="clip0_1241_1051">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UpArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_1241_1048)">
      <path d="M16.59 15.4102L12 10.8302L7.41 15.4102L6 14.0002L12 8.00016L18 14.0002L16.59 15.4102Z" fill="#0E0E0E" />
    </g>
    <defs>
      <clipPath id="clip0_1241_1048">
        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)" />
      </clipPath>
    </defs>
  </svg>
);

export const TriangleIconTooltipProfileView = () => {
  return (
    <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_3210_163)">
        <path d="M15 8L21.9282 17.75H8.0718L15 8Z" fill="#262626" />
      </g>
      <defs>
        <filter
          id="filter0_dd_3210_163"
          x="0.0722656"
          y="0"
          width="33.8555"
          height="29.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3210_163" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" dy="-2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_3210_163" result="effect2_dropShadow_3210_163" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3210_163" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const OfferStripIcon = () => {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.65418 9.79372C8.14897 9.79372 8.55007 9.39262 8.55007 8.89784C8.55007 8.40305 8.14897 8.00195 7.65418 8.00195C7.1594 8.00195 6.7583 8.40305 6.7583 8.89784C6.7583 9.39262 7.1594 9.79372 7.65418 9.79372Z"
        fill="#1E6A26"
      />
      <path
        d="M13.3392 13.4285C13.834 13.4285 14.2351 13.0274 14.2351 12.5326C14.2351 12.0378 13.834 11.6367 13.3392 11.6367C12.8445 11.6367 12.4434 12.0378 12.4434 12.5326C12.4434 13.0274 12.8445 13.4285 13.3392 13.4285Z"
        fill="#1E6A26"
      />
      <path
        d="M20.7302 11.8996L20.4052 11.456C20.0539 10.973 20.0451 10.3186 20.392 9.82676L20.7082 9.37882C21.1913 8.69373 20.9673 7.74076 20.2252 7.34112L19.7421 7.08202C19.2151 6.80096 18.9253 6.21248 19.0263 5.61962L19.1185 5.07945C19.259 4.25384 18.6398 3.4897 17.801 3.45457L17.2521 3.43261C16.6548 3.40626 16.1366 3.00223 15.9697 2.42694L15.816 1.89995C15.5833 1.09189 14.6962 0.674693 13.9232 1.00845L13.4182 1.22364C12.8693 1.46079 12.2281 1.32026 11.8285 0.872315L11.464 0.463897C10.9062 -0.159708 9.9269 -0.155317 9.37356 0.481464L9.01345 0.894273C8.61821 1.34661 7.98143 1.49592 7.42809 1.26756L6.91866 1.05676C6.14135 0.736176 5.26303 1.17094 5.03906 1.97899L4.89414 2.51038C4.73604 3.09007 4.22662 3.50288 3.62936 3.53362L3.08041 3.56436C2.24162 3.61266 1.63558 4.38558 1.78929 5.2112L1.89029 5.75137C2.00008 6.33984 1.71902 6.9327 1.19642 7.22255L0.717741 7.49044C-0.0156538 7.89885 -0.22645 8.85622 0.269799 9.53252L0.594777 9.97607C0.946104 10.4591 0.954887 11.1135 0.607952 11.6054L0.291757 12.0533C-0.191317 12.7384 0.0326537 13.6914 0.774832 14.091L1.25791 14.3501C1.7849 14.6312 2.07474 15.2196 1.97373 15.8125L1.88151 16.3527C1.74098 17.1783 2.36019 17.9424 3.19899 17.9775L3.74794 17.9995C4.34519 18.0259 4.8634 18.4299 5.03028 19.0052L5.18398 19.5322C5.41674 20.3402 6.30384 20.7574 7.07676 20.4237L7.58179 20.2085C8.13074 19.9713 8.77191 20.1119 9.17155 20.5598L9.53605 20.9682C10.0982 21.5918 11.0775 21.5874 11.6264 20.9506L11.9866 20.5378C12.3818 20.0855 13.0186 19.9362 13.5719 20.1646L14.0813 20.3754C14.8586 20.6959 15.737 20.2612 15.9609 19.4531L16.1059 18.9217C16.264 18.342 16.7734 17.9292 17.3706 17.8985L17.9196 17.8678C18.7584 17.8194 19.3644 17.0465 19.2107 16.2209L19.1097 15.6807C18.9999 15.0923 19.281 14.4994 19.8036 14.2096L20.2823 13.9417C21.0157 13.5377 21.2265 12.5803 20.7302 11.8996ZM5.487 8.89574C5.487 7.70123 6.45315 6.73508 7.64766 6.73508C8.84218 6.73508 9.80832 7.70123 9.80832 8.89574C9.80832 10.0903 8.84218 11.0564 7.64766 11.0564C6.45315 11.0564 5.487 10.0859 5.487 8.89574ZM8.06487 14.4687C7.88042 14.6926 7.54666 14.7234 7.32269 14.5389C7.09872 14.3545 7.06798 14.0207 7.25242 13.7968L12.922 6.96784C13.1064 6.74387 13.4402 6.71313 13.6641 6.89757C13.8881 7.08202 13.9188 7.41578 13.7344 7.63975L8.06487 14.4687ZM13.3436 14.6926C12.149 14.6926 11.1829 13.7265 11.1829 12.532C11.1829 11.3375 12.149 10.3713 13.3436 10.3713C14.5381 10.3713 15.5042 11.3375 15.5042 12.532C15.5042 13.7265 14.5381 14.6926 13.3436 14.6926Z"
        fill="#1E6A26"
      />
    </svg>
  );
};
